import { usePage } from '@inertiajs/vue3';

export function useRouter() {
	const page = usePage();

	const toRoute = (routeName, params) => {
		const subdomain = page.props.subdomain;

		return route(routeName, { subdomain, ...params });
	};

	return { toRoute };
}
